import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { disabled, focusOutsetThick } from '../styles/util';
export var StyledButton = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", ";\n\t> *:focus {\n\t\toutline: none;\n\t}\n\t:focus > :first-of-type {\n\t\t", ";\n\t}\n"])), function (props) {
  return props.disabled && css(disabled);
}, css(focusOutsetThick));